import { type FC } from "react";
import { StyledRectangleContainer, StyledContainer } from "./styled";

const ThreeBigHorizontalCardsBlockPlaceholder: FC = () => {
  return (
    <StyledContainer>
      <Rectangle />
      <Rectangle />
      <Rectangle />
    </StyledContainer>
  );
};

const Rectangle: FC = () => {
  return <StyledRectangleContainer />;
};

export default ThreeBigHorizontalCardsBlockPlaceholder;
